import React from 'react';
import FeatureDetail from '../components/features/FeatureDetail';

const FeatureView = () => {
  return (
    <div className="container mx-auto px-4 py-8">
      <FeatureDetail />
    </div>
  );
};

export default FeatureView; 